module.exports = __webpack_public_path__ + "images/search@2x.png?d9e229b8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search@2x.png
// module id = 696
// module chunks = 7